import FormController from '@controllers/portal/components/form_controller';

export default class extends FormController {

  static targets = ['hiddenField', 'optionItem', 'allOptionsToggleButton', 'positionField', 'toggleButton'];

  minSelectionInput = null;
  maxSelectionInput = null;

  // Setup text inputs
  textInputReady(e) {
    const controller = e.detail.input;

    if (controller.name === 'min_selections') this.minSelectionInput = controller;
    else if (controller.name === 'max_selections') this.maxSelectionInput = controller;
  }

  validate(e) {
    let valid = super.validate(e);

    if (this.minSelectionInput && this.maxSelectionInput) {
      // Count active options
      const activeOptionsCount = this.hiddenFieldTargets.filter(field => field.value !== 'true').length;
      // If both min and max selections are set, max should be >= min
      if (this.minSelectionInput.currentValue > 0 && this.maxSelectionInput.currentValue < this.minSelectionInput.currentValue) {
        this.maxSelectionInput.setError('Maximum selections must be greater than or equal to minimum selections.');
        valid = false;
      } else if (this.maxSelectionInput.currentValue > activeOptionsCount) {
        this.maxSelectionInput.setError(`Maximum selections cannot exceed the number of active options (${activeOptionsCount}).`);
        valid = false;
      } else {
        this.maxSelectionInput.clearError();
      }
    }

    if (!valid) {
      e.preventDefault();
      this.formTarget.querySelector('.error').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return valid;
  }
  
  allHidden() {
    return (
      this.hiddenFieldTargets.length > 0 &&
      this.hiddenFieldTargets.every(f => f.value === 'true')
    );
  }
    setOptionHidden(optionId, hidden, button = null) {
    // Find the hidden field for this option
    const hiddenField = this.hiddenFieldTargets.find(field => field.dataset.optionId === optionId);
    if (!hiddenField) return;
    const optionItem = this.optionItemTargets.find(item => item.dataset.optionsListId === optionId);

    
    if (!button) {
      button = this.toggleButtonTargets.find(btn => btn.dataset.optionId === optionId);
    }
    if (!button) return;
    hiddenField.value = String(hidden);
  
    // Update icons
    const hideIcon = button.querySelector('.option-hide');
    const showIcon = button.querySelector('.option-show');
    
    if (hideIcon) hideIcon.style.display = hidden ? 'none' : 'inline';
    if (showIcon) showIcon.style.display = hidden ? 'inline' : 'none';
    optionItem.classList.toggle('option-hidden', hidden);
    
    // Update tooltip content
    const newContent = hidden ? 'Show option' : 'Hide option';
    button.dataset.content = newContent;
  
    // Force tooltip to re-read the data-content attribute
    const tooltipController = this.application.getControllerForElementAndIdentifier(button, 'tooltip');
    if (tooltipController && tooltipController.update) {
      tooltipController.update(newContent);
    }
  }

  toggleOption(e) {
    e.preventDefault();
    const button = e.currentTarget;
    const optionId = button.dataset.optionId;
    const hiddenField = this.hiddenFieldTargets.find(field => field.dataset.optionId === optionId);
    if (!hiddenField) return;

    const isHidden = hiddenField.value === 'true';
    this.setOptionHidden(optionId, !isHidden, button);
    this.syncAllOptionsToggleUI();
  }

  toggleAllOptions(e) {
    e.preventDefault();
    const desiredHidden = !this.allHidden();
    this.hiddenFieldTargets.forEach(field => {
      const optionId = field.dataset.optionId;
      if (!optionId) return;
      const isHidden = field.value === 'true';
      if (isHidden === desiredHidden) return; // No change needed
      this.setOptionHidden(optionId, desiredHidden);
    });
    this.syncAllOptionsToggleUI();
  }

  syncAllOptionsToggleUI() {
    if(!this.hasAllOptionsToggleButtonTarget) return;
    const allHidden = this.allHidden();
    const masterBtn = this.allOptionsToggleButtonTarget;

    const showIcon = masterBtn.querySelector('.option-show');
    const hideIcon = masterBtn.querySelector('.option-hide');
    
    showIcon.style.display = allHidden ? 'inline' : 'none';
    hideIcon.style.display = allHidden ? 'none' : 'inline';
    
    const labelText = allHidden ? 'Show all options' : 'Hide all options';

    // Force tooltip to re-read the data-content attribute
    const labelEl = masterBtn.querySelector('.toggle-label');
    if (labelEl) labelEl.textContent = labelText;

    masterBtn.dataset.content = labelText;
  }
  
  moveOptionUp(e) {
    const optionId = e.currentTarget.dataset.optionId;
    const currentItem = this.findOptionItem(optionId);
    const previousItem = currentItem.previousElementSibling;
    
    if (previousItem) {
      currentItem.parentNode.insertBefore(currentItem, previousItem);
    } else {
      currentItem.parentNode.appendChild(currentItem);
    }
    
    this.updateAllPositions();
  }

  moveOptionDown(e) {
    const optionId = e.currentTarget.dataset.optionId;
    const currentItem = this.findOptionItem(optionId);
    const nextItem = currentItem.nextElementSibling;
    
    if (nextItem) {
      currentItem.parentNode.insertBefore(currentItem, nextItem.nextElementSibling);
    } else {
      currentItem.parentNode.insertBefore(currentItem, currentItem.parentNode.firstChild);
    }
    
    this.updateAllPositions();
  }
  
  findOptionItem(optionId) {
    return this.optionItemTargets.find(item => item.dataset.optionsListId === optionId);
  }

  updateAllPositions() {
    this.optionItemTargets.forEach((item, index) => {
      const newPosition = index + 1;
      const optionId = item.dataset.optionsListId;
      const positionField = this.positionFieldTargets.find(field => field.dataset.optionId === optionId);
      console.log(positionField)
      if (positionField) {
        positionField.value = newPosition;
      }
    });
  }
}
